import { render, staticRenderFns } from "./percentListComponent.vue?vue&type=template&id=083d8488"
import script from "./percentListComponent.vue?vue&type=script&lang=js"
export * from "./percentListComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('083d8488')) {
      api.createRecord('083d8488', component.options)
    } else {
      api.reload('083d8488', component.options)
    }
    module.hot.accept("./percentListComponent.vue?vue&type=template&id=083d8488", function () {
      api.rerender('083d8488', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/DashboardDinamic/percentListComponent.vue"
export default component.exports